import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { AppMenuComponent } from './app-menu.component';

@NgModule({
  declarations: [AppMenuComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslocoModule,
  ]
})
export class AppMenuModule { }
